import { Box } from "@chakra-ui/react";
import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import { Control } from "react-hook-form";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import SelectCnae from "ui/components/Input/SelectCnae";
import SelectClassificacaoTributaria from "ui/components/Input/SelectClassificacaoTributaria";
import SelectNaturezaJuridica from "ui/components/Input/SelectNaturezaJuridica";

function DadosDeTributacao({
  control,
}: {
  control: Control<TenantDetalhe, object>;
}) {
  return (
    <Box>
      <Row gutter={16}>
        <Box as={Col} md={8} mb={3}>
          <Field
            label="CNAE"
            control={control}
            name="pessoa.cnaeId"
            render={({ field }) => <SelectCnae {...field} />}
          />
        </Box>

        <Box as={Col} md={8} mb={3}>
          <Field
            label="Classificação Tributária"
            control={control}
            name="pessoa.classificacaoTributariaId"
            render={({ field }) => <SelectClassificacaoTributaria {...field} />}
          />
        </Box>

        <Box as={Col} md={8} mb={3}>
          <Field
            label="Natureza Jurídica"
            control={control}
            name="pessoa.naturezaJuridicaId"
            render={({ field }) => <SelectNaturezaJuridica {...field} />}
          />
        </Box>
      </Row>
    </Box>
  );
}

export default DadosDeTributacao;
